const list = [
	" daum[/|\\s]",
	" deusu/",
	"(?:^|\\s)site",
	"@[a-z]",
	"\\(at\\)[a-z]",
	"\\(github\\.com/",
	"\\[at\\][a-z]",
	"^12345",
	"^<",
	"^ace explorer",
	"^acoon",
	"^active",
	"^ad muncher",
	"^ahc/",
	"^anglesharp/",
	"^anonymous",
	"^apache",
	"^applicationhealthservice",
	"^arachni/",
	"^astute srm",
	"^avsdevicesdk/",
	"^axios/",
	"^bidtellect/",
	"^biglotron",
	"^blackboard safeassign",
	"^blocknote.net",
	"^blogtrottr/",
	"^browsershots",
	"^cakephp",
	"^camo asset proxy",
	"^captivenetworksupport",
	"^castro",
	"^clamav[\\s/]",
	"^cobweb/",
	"^coccoc",
	"^coldfusion",
	"^collectd/",
	"^custom$",
	"^dap ",
	"^datadog agent/",
	"^davclnt",
	"^deluge",
	"^discourse",
	"^dispatch/\\d",
	"^disqus/",
	"^duckduckgo",
	"^enigma browser",
	"^evernote clip resolver",
	"^facebook",
	"^faraday",
	"^fdm[/\\s]\\d",
	"^flashget",
	"^friendica",
	"^getright/",
	"^gigablastopensource",
	"^googal",
	"^goose",
	"^gozilla/",
	"^greenbrowser",
	"^hatena",
	"^hexometer",
	"^hobbit",
	"^hotzonu",
	"^hwcdn/",
	"^infox-wisg",
	"^ingrid/\\d",
	"^integrity/",
	"^jeode/",
	"^jetbrains",
	"^jetty/",
	"^jigsaw",
	"^libwww",
	"^linkdex",
	"^lwp-",
	"^lwp::simple",
	"^mailchimp\\.com$",
	"^metauri",
	"^microsoft bits",
	"^microsoft data",
	"^microsoft office existence",
	"^microsoft office protocol discovery",
	"^microsoft windows network diagnostics",
	"^microsoft-cryptoapi",
	"^microsoft-webdav-miniredir",
	"^monit",
	"^movabletype",
	"^mozilla/\\d\\.\\d \\(compatible;?\\)$",
	"^my browser$",
	"^navermailapp",
	"^netsurf",
	"^nibbler",
	"^ning",
	"^node-superagent",
	"^notetextview",
	"^nuzzel",
	"^octopus",
	"^offline explorer",
	"^ossproxy",
	"^pagething",
	"^panscient",
	"^pearltrees",
	"^perimeterx",
	"^photon/",
	"^php",
	"^postman",
	"^postrank",
	"^prometheus/",
	"^python",
	"^ramblermail",
	"^restsharp/",
	"^robozilla/",
	"^ruby$",
	"^scrapy",
	"^seo",
	"^shareaza",
	"^shockwave flash",
	"^shortlinktranslate",
	"^sistrix",
	"^sixy.ch/",
	"^smallproxy",
	"^snap$",
	"^snapchat",
	"^space bison",
	"^spotify/",
	"^sprinklr",
	"^svn",
	"^swcd ",
	"^t-online browser",
	"^taringa",
	"^test certificate info",
	"^the knowledge ai",
	"^thinklab",
	"^thumb",
	"^traackr.com",
	"^transmission",
	"^tumblr/",
	"^ucmore",
	"^upflow/",
	"^user_agent",
	"^vbulletin",
	"^venus/fedoraplanet",
	"^viber$",
	"^w3c",
	"^webbandit/",
	"^webcollage/",
	"^webcopier",
	"^wget",
	"^whatsapp",
	"^whatweb",
	"^www-mechanize",
	"^xenu link sleuth",
	"^xymon",
	"^yahoo",
	"^yandex",
	"^zabbix",
	"^zdm/\\d",
	"^zeushdthree",
	"^zmeu$",
	"adbeat\\.com",
	"amiga",
	"appinsights",
	"archive",
	"ask jeeves/teoma",
	"bit.ly/",
	"bluecoat drtr",
	"bot",
	"browsex",
	"burpcollaborator",
	"capture",
	"catch",
	"check",
	"chrome-lighthouse",
	"chromeframe",
	"client",
	"cloud",
	"crawl",
	"cron",
	"daemon",
	"dareboost",
	"datanyze",
	"dataprovider",
	"dejaclick",
	"dmbrowser",
	"download",
	"email",
	"evc-batch/",
	"feed",
	"fetch",
	"finder",
	"firephp",
	"freesafeip",
	"ghost",
	"gomezagent",
	"google",
	"headlesschrome/",
	"http",
	"httrack",
	"hubspot marketing grader",
	"hydra",
	"ibisbrowser",
	"images",
	"index",
	"ips-agent",
	"java",
	"jorgee",
	"library",
	"mail\\.ru/",
	"manager",
	"monitor",
	"neustar wpm",
	"news",
	"nutch",
	"offbyone",
	"optimize",
	"pagespeed",
	"parse",
	"perl",
	"phantom",
	"pingdom",
	"powermarks",
	"preview",
	"probe",
	"ptst[/ ]\\d",
	"reader",
	"rigor",
	"rss",
	"scan",
	"scrape",
	"search",
	"server",
	"sogou",
	"sparkler/",
	"spider",
	"statuscake",
	"stumbleupon\\.com",
	"supercleaner",
	"synapse",
	"synthetic",
	"toolbar",
	"torrent",
	"tracemyfile",
	"transcoder",
	"trendsmapresolver",
	"twingly recon",
	"url",
	"valid",
	"virtuoso",
	"wappalyzer",
	"webglance",
	"webkit2png",
	"websitemetadataretriever",
	"whatcms/",
	"wordpress",
	"zgrab"
];

/**
 * Mutate given list of patter strings
 * @param {string[]} list
 * @returns {string[]}
 */
function amend (list) {
  try {
    // Risk: Uses lookbehind assertion, avoid breakage in parsing by using RegExp constructor
    new RegExp('(?<! cu)bot').test('dangerbot'); // eslint-disable-line prefer-regex-literals
    // Addresses: Cubot device
    list.splice(list.lastIndexOf('bot'), 1);
    list.push('(?<! cu)bot');
    // Addresses: Android webview
    list.splice(list.lastIndexOf('google'), 1);
    list.push('(?<! (channel\\/|google\\/))google(?!(app|\\/google))');

    // Addresses: Yandex browser
    list.splice(list.lastIndexOf('search'), 1);
    list.push('(?<! (ya|yandex))search');
    // Addresses: libhttp browser
    list.splice(list.lastIndexOf('http'), 1);
    list.push('(?<!(lib))http');
    // Addresses: java based browsers
    list.splice(list.lastIndexOf('java'), 1);
    list.push('java(?!;)');
    // Addresses: java based browsers
    list.splice(list.lastIndexOf('fetch'), 1);
    list.push('(?<!(mozac))fetch');
  } catch (error) {
    // ignore errors
  }
  return list
}

amend(list);
let pattern;

/**
 * Refresh the local regex variable (clusure)
 */
function update () {
  pattern = new RegExp(list.join('|'), 'i');
}

/**
 * Check if string matches known crawler patterns
 * @param  {string} ua User Agent String
 * @return {boolean}
 */
const isbot = ua => pattern.test(ua);

/**
 * Get the match for strings' known crawler pattern
 * @param  {string} ua
 * @return {string}
 */
function find (ua) {
  const match = ua.match(pattern);
  return match && match[0]
}

/**
 * Find the first index of an existing rule or -1 if not found
 * @param  {string} rule
 * @returns {number}
 */
const indexOf = (rule) => list.indexOf(rule.toLowerCase());

/**
 * Check if item is included in list
 * @param  {string} rule
 * @return {boolean}
 */
const included = (rule) => indexOf(rule) === -1;

/**
 * Extent patterns for known crawlers
 * @param  {string[]} filters
 * @return {void}
 */
function extend (filters) {
  [].push.apply(
    list,
    filters.filter(included).map(filter => filter.toLowerCase())
  );
  update();
}

/**
 * Exclude patterns from bot pattern rule
 * @param  {string[]} filters
 * @return {void}
 */
function exclude (filters) {
  let { length } = filters;
  while (length--) {
    const index = indexOf(filters[length]);
    if (index > -1) {
      list.splice(index, 1);
    }
  }
  update();
}

Object.defineProperties(
  isbot,
  {
    find: { get: () => find },
    extend: { get: () => extend },
    exclude: { get: () => exclude }
  }
);

update();

export default isbot;
//# sourceMappingURL=index.mjs.map
